import React from 'react';
import styled from 'styled-components';
import { useEditMode } from '../../shared/hooks/useEditMode';
import { WorkContentMode } from '../../shared/enum/EnumRepository';
import { useSettingStore } from '../../shared/store/settingStore';
import { useWorkContentModeStore } from '../../shared/store/workContentModeStore';
import { useWorkPropertyVisibleStore } from '../../shared/store/workPropertyVisibleStore';
import { useWorkViewStore } from '../../shared/store/WorkViewStore';
import { resolveWorkArtistName, shouldShowWorkArtist } from '../../shared/util/workArtist';
import { isWorkEnglishShown } from '../../shared/util/workDisplayText';
import WorkArtistEditor from './WorkArtistEditor';
import WorkArtistName from './WorkArtistName';

const WorkArtistInViewer: React.FC = () => {
  const { isEditMode } = useEditMode();
  const setting = useSettingStore((state) => state.setting);
  const workContentMode = useWorkContentModeStore((state) => state.workContentMode);
  const engVisible = useWorkPropertyVisibleStore(
    (state) => state.workPropertyVisible?.engVisible !== false,
  );
  const activeWork = useWorkViewStore((s) => s.activeWork);
  const updateActiveWork = useWorkViewStore((s) => s.updateActiveWork);

  if (!activeWork || !shouldShowWorkArtist(setting)) return null;

  if (isEditMode) {
    return (
      <EditorWrapper>
        <WorkArtistEditor
          artist={activeWork.artist}
          workContentMode={workContentMode}
          onChange={(artist) => updateActiveWork({ artist })}
        />
      </EditorWrapper>
    );
  }

  const name = resolveWorkArtistName(activeWork.artist, workContentMode, engVisible);
  if (!name) return null;

  return (
    <ArtistRow>
      <ArtistLabel>
        Artist {isWorkEnglishShown(workContentMode, engVisible, false) ? '(en)' : ''}
      </ArtistLabel>
      <ArtistValue>
        <WorkArtistName artist={activeWork.artist} name={name} />
      </ArtistValue>
    </ArtistRow>
  );
};

export default WorkArtistInViewer;

const EditorWrapper = styled.div`
  padding-right: 2px;
  margin-bottom: 4px;
`;

const ArtistRow = styled.div`
  min-height: 18px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  ${({ theme }) => theme.typography.Body_04};
`;

const ArtistLabel = styled.span`
  min-width: 70px;
  padding-top: 2px;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  font-weight: 500;
`;

const ArtistValue = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  text-align: left;
  white-space: normal;
  word-break: break-word;
`;
